<template>
	<el-scrollbar style="height: 100%;background-color: #EBF1F3;">

		<!-- <div v-if="juese==12" class="firstPagea">
			<el-row :gutter="20">
				<el-col :span="6" :offset="8">
					<div class="logo1"><img style="height: 200px;" src="~assets/logo.png"></div>

				</el-col>
			</el-row>

		</div> -->
		<div class="firstPage" v-bind:style="{height:EchartsHeight}">
			<!-- <div class="itemConone"> -->
				<img src="../../assets/home/toubu.png" class="itemTopImage">
			<!-- </div> -->
			<div class="list">
				<div class="item" v-for="(item, index) in list" :key="index">
					<div class="itemBox">

						<div class="itemCon">
							<div class="itemNum">{{item.title}}</div>
							<div class="itemBottom">
								<span class="itemBottomTitle">{{item.num}}</span>
							</div>
						</div>
						<div class="itemConone">
							<!-- <image class="itemBottomImage" :src="item.image"></image> -->
							<img v-if="item.title=='待我处理'" src="../../assets/home/daiwochuli.png"
								class="itemBottomImage">
							<img v-if="item.title=='我创建的'" src="../../assets/home/wochuangjiande.png"
								class="itemBottomImage">
							<img v-if="item.title=='提醒我的'" src="../../assets/home/tixingwode.png"
								class="itemBottomImage">
							<img v-if="item.title=='全部实施项目'" src="../../assets/home/quanbushishixiangmu.png"
								class="itemBottomImage">
							<img v-if="item.title=='未完成实施项目'" src="../../assets/home/weiwanchengshishixiangmu.png"
								class="itemBottomImage">
							<img v-if="item.title=='即将到期项目'" src="../../assets/home/jijiangdaoqixiangmu.png"
								class="itemBottomImage">

							<!-- <span class="itemBottomImage">{{item.num}}</span> -->
						</div>
					</div>

				</div>
			</div>
			<div class="list">

				<div class="item" v-for="(item, index) in listone" :key="index">

					<div class="itemBoxtwo">

						<div class="itemTop">

							<span class="itemTopText">{{item.TITLE}}</span>

						</div>
						<div class="itemContwo">

							<div class="itemMokuai" v-for="(itema, indexa) in item.Child" :key="indexa"
								@click="GongnengTiaoZhuan(itema.TOUTE)">
								<img v-if="itema.TITLE=='未接工单'" src="../../assets/home/weijiegongdan.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='已接工单'" src="../../assets/home/yijiegongdan.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='客服已完成工单'" src="../../assets/home/yiwanchenggongdan.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='全部工单查询'" src="../../assets/home/quanbugongdan.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='新建工单'" src="../../assets/home/xinjiangongdan.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='客服工单统计'" src="../../assets/home/yiwanchenggongdan.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='客户已完成工单'" src="../../assets/home/yiwanchenggongdan.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='客户全部工单查询'" src="../../assets/home/gongdanchaxun.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='客户新建工单'" src="../../assets/home/xinjiangongdan.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='账号注册'" src="../../assets/home/zhanghaozhuce.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='客户注册'" src="../../assets/home/kehuzhuce.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='客户查询'" src="../../assets/home/kehuchaxun.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='非客户账号查询'"
									src="../../assets/home/feikehuzhanghaochaxun.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='权限分配'" src="../../assets/home/quanxianfenpei.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='权限新增'" src="../../assets/home/quanxianxinzeng.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='查询权限'" src="../../assets/home/quanxianchaxun.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='字典新增'" src="../../assets/home/zidianxinzeng.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='字典查询'" src="../../assets/home/zidianchaxun.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='实施申请添加'" src="../../assets/home/shishishenqing.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='发起的实施申请列表'" src="../../assets/home/wofaqide.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else-if="itema.TITLE=='参与实施的模版列表'"
									src="../../assets/home/quanbushishixiangmu.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">
								<img v-else src="../../assets/home/daiwochuli.png"
									style="width: 60px;height: 60px;padding-top: 20px;padding-left: 20px;">

								<div
									style="width: auto;text-align: center;margin-top: 5px;margin-bottom: 20px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;">
									{{itema.TITLE}}
								</div>
							</div>

						</div>

					</div>
				</div>
			</div>
		</div>
	</el-scrollbar>
</template>

<script>
	export default {
		name: 'kefuzhanwei',
		data() {
			return {
				EchartsHeight: document.body.clientHeight + 'px',
				juese: JSON.parse(localStorage.getItem("userInfo")).ROLE,
				list: [],
				listone: JSON.parse(localStorage.getItem("userInfo")).POWERS
			}
		},
		mounted() {
			window.onresize = () => {
				// console.log(document.body.clientHeight)
				// return (() => {
				window.screenHeight = document.body.clientHeight
				this.EchartsHeight = window.screenHeight + 'px'

			}
			this.getMode()
		},
		activated() {
			const that = this;
			window.onresize = () => {
				// console.log(document.body.clientHeight)
				// return (() => {
				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = window.screenHeight + 'px'

				// })()
			}

		},

		methods: {
			// 设置功能区域跳转
			setItem(item) {
				let el = document.querySelector('#menu' + item.parentName)
				if (!el.parentNode.parentNode.attributes['aria-expanded']) {
					el.click()
				}
				document.querySelector('#menuTwo' + item.name).click()
			},
			//功能跳转
			GongnengTiaoZhuan(item) {
				this.$router.push({
					path: item
				});
			},
			getMode() {

				this.$request({
					method: 'post',
					url: "Home/Information",
				}).then(res => {
					console.log(res.Data)

					if (res.Code == 0) {
						let lista = []
						if (this.juese != 12) {

							lista.push({
								title: '待我处理',
								num: res.Data.DISPOSE_NUMBER
							})
							lista.push({
								title: '我创建的',
								num: res.Data.CREATE_NUMBER
							})
							lista.push({
								title: '提醒我的',
								num: res.Data.REMIND_NUMBER
							})
							lista.push({
								title: '全部实施项目',
								num: res.Data.PARTICIPATION_NUMBER
							})
							lista.push({
								title: '未完成实施项目',
								num: res.Data.UNDONE_NUMBER
							})
							lista.push({
								title: '即将到期项目',
								num: res.Data.EXPIRE_NUMBER
							})

						} else {
							lista.push({
								title: '待评价',
								num: res.Data.TOEVAL_NUMBER
							})
							lista.push({
								title: '我创建的',
								num: res.Data.CREATE_NUMBER
							})
							lista.push({
								title: '提醒我的',
								num: res.Data.REMIND_NUMBER
							})
						}

						this.list = lista

					}
				}).catch((err) => {
					window.console.log(err);
				});
			}
		},
	}
</script>

<style scoped>
	.firstPage {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		padding: 20px;
		background-color: #EBF1F3;
	}

	.logo1 {
		line-height: 100px;
		text-align: center;
	}

	.firstPagea {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		padding: 20px;
		background-color: #FFFFFF;
	}

	.list {
		/* display: flex; */
		/* justify-content: space-between; */
		align-items: flex-start;
		width: 100%;
		margin-top: 20px;


		box-sizing: border-box;

		word-break: break-all;
	}

	.item {
		width: 31%;
		display: inline-block;
		margin-left: 30px;
		margin-bottom: 20px;
	}

	.itemBox {
		box-sizing: border-box;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		height: 120px;
		border: 1px solid #EBEEF5;
		background-color: #FFF;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
	}

	.itemBoxtwo {
		display: grid;
		box-sizing: border-box;
		/* display: flex; */
		/* justify-content: flex-start; */
		align-items: center;
		width: 100%;
		border: 1px solid #EBEEF5;
		background-color: #FFF;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
		box-sizing: border-box;
		width: 100%;
		word-break: break-all;
	}

	.itemTop {
		box-sizing: border-box;
		display: flex;

		align-items: center;
		width: 100%;
		height: 50px;
		padding: 0 20px;
		border-bottom: 1px solid #F2F4F9;
	}

	.itemTopText {
		display: inline-block;
		font-size: 16px;
		color: #333;
		line-height: 20px;
		font-weight: bold;
	}

	.itemCon {
		/* box-sizing: border-box; */
		/* display: inline-block; */
		width: 75%;
		padding: 0 20px;
	}

	.itemConone {
		/* display: inline-block; */
		box-sizing: border-box;
		width: auto;
		height: 100px;

		/* padding: 0 20px; */
	}

	.itemContwo {
		/* display: inline-block; */
		/* display: flex; */
		box-sizing: border-box;
		width: 100%;
		word-break: break-all;
		/* padding: 0 20px; */
	}

	.itemMokuai {
		display: inline-block;
		box-sizing: border-box;
		width: 100px;
		margin-left: 25px;
	}

	.itemBottomImage {
		padding: 20px;
		width: 60px;
		height: 60px;

		/* background-color: #242424; */
	}
	.itemTopImage{
		padding-left: 30px;
		padding-right: 30px;
		width: 97%;
	}


	.itemNum {
		width: 100%;
		font-size: 16px;
		color: #666666;
		font-family: Microsoft YaHei-Regular, M;
		line-height: 50px;
		/* border-bottom: 1px solid #F2F4F9; */
	}

	.itemBottom {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 50px;
	}

	.itemBottomTitle {
		display: inline-block;
		font-size: 26px;
		color: #646464;
		line-height: 70px;
	}

	.itemBottomText {
		display: inline-block;
		font-size: 16px;
		color: #646464;
		line-height: 70px;
	}



	.itemFunView {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		margin-top: 20px;
	}

	.itemFun {
		display: flex;
		justify-content: center;
		align-content: center;
		flex-wrap: wrap;
		width: 48%;
		height: 80px;
		border-radius: 4px;
		background-color: #fff;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
		cursor: pointer;
	}

	.itemFunImg {
		width: 40px;
		height: 40px;
		font-size: 40px;
	}

	.itemFunText {
		display: block;
		width: 100%;
		height: 30px;
		font-size: 16px;
		color: #242424;
		line-height: 30px;
		text-align: center;
	}

	.census {
		width: 100%;
		margin-top: 20px;
		background-color: #fff;
		border-radius: 4px;
		border: 1px solid #EBEEF5;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
	}

	.censusTitle {
		box-sizing: border-box;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		height: 50px;
		padding: 0 20px;
		border-bottom: 1px solid #F0F0F7;
	}

	.censusTitleImg {
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}

	.censusTitleText {
		display: inline-block;
		font-size: 18px;
		color: #4D4F5C;
		line-height: 30px;
	}

	.censusCon {
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 400px;
		padding: 20px 0;
	}

	.censusConItem {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		padding: 0 20px;
	}

	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}
</style>
